import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const HistorieList = lazy(() =>
  import('@/modules/uskladneni/HistorieList').then((m) => ({ default: m.HistorieList })),
);

interface HistorieSearch {
  spz?: string;
  od?: string;
  do?: string;
}

function parseHistorieSearch(
  input: Record<string, unknown>,
): HistorieSearch {
  const out: HistorieSearch = {};
  for (const key of ['spz', 'od', 'do'] as const) {
    const value = input[key];
    if (typeof value === 'string' && value.trim() !== '') {
      out[key] = value;
    }
  }
  return out;
}

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/servis/historie',
  component: () => (
    <Suspense fallback={null}>
      <HistorieList />
    </Suspense>
  ),
  validateSearch: parseHistorieSearch,
});
